/* TRNDZFASHION Theme JS — OS 2.0 */

(function() {
  'use strict';

  // ===== PROMO POPUP =====
  function initPromoPopup() {
    var overlay = document.getElementById('trndz-popup-overlay');
    if (!overlay) return;
    if (sessionStorage.getItem('trndzfashion_promo_seen')) return;

    var timer = setTimeout(function() { overlay.style.display = 'flex'; }, 3000);

    function dismiss() {
      overlay.style.display = 'none';
      sessionStorage.setItem('trndzfashion_promo_seen', '1');
    }

    var bg = overlay.querySelector('.trndz-popup-bg');
    var closeBtn = overlay.querySelector('.trndz-popup__close');
    var skipBtn = overlay.querySelector('.trndz-popup__skip');
    var form = overlay.querySelector('.trndz-popup__form-wrap');
    var successEl = overlay.querySelector('.trndz-popup__success');

    if (bg) bg.addEventListener('click', dismiss);
    if (closeBtn) closeBtn.addEventListener('click', dismiss);
    if (skipBtn) skipBtn.addEventListener('click', dismiss);

    var formEl = overlay.querySelector('form');
    if (formEl) {
      formEl.addEventListener('submit', function(e) {
        e.preventDefault();
        sessionStorage.setItem('trndzfashion_promo_seen', '1');
        if (form) form.style.display = 'none';
        if (successEl) successEl.style.display = 'block';
        setTimeout(dismiss, 2500);
      });
    }
  }

  // ===== MOBILE DRAWER =====
  function initDrawer() {
    var overlay = document.getElementById('trndz-drawer-overlay');
    if (!overlay) return;
    var openBtn = document.getElementById('trndz-burger');
    var closeBtn = document.getElementById('trndz-drawer-close');

    function open() { overlay.classList.add('is-open'); document.body.style.overflow = 'hidden'; }
    function close() { overlay.classList.remove('is-open'); document.body.style.overflow = ''; }

    if (openBtn) openBtn.addEventListener('click', open);
    if (closeBtn) closeBtn.addEventListener('click', close);

    overlay.addEventListener('click', function(e) {
      if (e.target === overlay || e.target.classList.contains('trndz-drawer-overlay')) close();
    });

    var drawerLinks = overlay.querySelectorAll('.trndz-drawer__nav a');
    drawerLinks.forEach(function(link) { link.addEventListener('click', close); });
  }

  // ===== HERO ROTATOR =====
  function initHeroRotator() {
    var slides = document.querySelectorAll('.trndz-hero__slide');
    if (slides.length <= 1) return;
    var current = 0;
    setInterval(function() {
      slides[current].classList.remove('is-active');
      current = (current + 1) % slides.length;
      slides[current].classList.add('is-active');
    }, 5000);
  }

  // ===== TOP BAR ROTATOR =====
  function initTopBarRotator() {
    var messages = document.querySelectorAll('.trndz-topbar__msg');
    if (messages.length <= 1) return;
    var current = 0;
    messages[0].style.display = 'block';
    setInterval(function() {
      messages[current].style.display = 'none';
      current = (current + 1) % messages.length;
      messages[current].style.display = 'block';
    }, 3000);
  }

  // ===== PRODUCT GALLERY =====
  function initProductGallery() {
    var thumbs = document.querySelectorAll('.trndz-product-gallery__thumb');
    var mainImg = document.querySelector('.trndz-product-gallery__main img');
    if (!mainImg || !thumbs.length) return;
    thumbs.forEach(function(thumb) {
      thumb.addEventListener('click', function() {
        var src = thumb.getAttribute('data-src');
        if (src) { mainImg.src = src; }
        thumbs.forEach(function(t) { t.style.borderColor = ''; });
        thumb.style.borderColor = '#ffffff';
      });
    });
  }

  // ===== STICKY HEADER SHRINK =====
  function initStickyNav() {
    var nav = document.querySelector('.trndz-nav');
    if (!nav) return;
    window.addEventListener('scroll', function() {
      if (window.scrollY > 60) {
        nav.style.borderBottomColor = '#3a3a3a';
      } else {
        nav.style.borderBottomColor = '#2a2a2a';
      }
    }, { passive: true });
  }

  function initSearch() {
    var overlay = document.getElementById('trndz-search-overlay');
    var openBtn = document.getElementById('trndz-search-open');
    var closeBtn = document.getElementById('trndz-search-close');
    var input = document.getElementById('trndz-search-input');
    if (!overlay || !openBtn) return;
    function open() { overlay.classList.add('is-open'); overlay.setAttribute('aria-hidden','false'); if (input) { input.value = ''; input.focus(); } }
    function close() { overlay.classList.remove('is-open'); overlay.setAttribute('aria-hidden','true'); }
    openBtn.addEventListener('click', open);
    if (closeBtn) closeBtn.addEventListener('click', close);
    overlay.querySelector('.trndz-search-overlay__bg').addEventListener('click', close);
    document.addEventListener('keydown', function(e) { if (e.key === 'Escape') close(); });
  }

  function initSizeButtons() {
    var groups = document.querySelectorAll('.trndz-size-btns');
    groups.forEach(function(group) {
      var btns = group.querySelectorAll('.trndz-size-btn');
      var select = group.parentElement.querySelector('.trndz-product-info__variant-select');
      btns.forEach(function(btn) {
        btn.addEventListener('click', function() {
          btns.forEach(function(b) { b.classList.remove('is-selected'); });
          btn.classList.add('is-selected');
          if (select) {
            select.value = btn.getAttribute('data-value');
            select.dispatchEvent(new Event('change', { bubbles: true }));
          }
        });
      });
    });
  }

  // Init all
  document.addEventListener('DOMContentLoaded', function() {
    initPromoPopup();
    initDrawer();
    initHeroRotator();
    initTopBarRotator();
    initProductGallery();
    initStickyNav();
    initSizeButtons();
    initSearch();
  });
})();
